// @ts-check

/** @typedef {import('axios').AxiosInstance} AxiosInstance */
/**
 * @template T
 * @typedef {import('axios').AxiosResponse<T>} AxiosResponse
 */

// Base URL'i environment variable'dan al, yoksa default değeri kullan
const API_BASE_URL_NEW =
  process.env.VUE_APP_API_URL_NEW || "https://api.second-phone-test.com/api";

const ENDPOINT_PATH = Object.freeze({
  ECHO: "echo",
  SETTINGS: "settings",
  DEVICE_REGISTER: "device/register",
  CONFIRM_PAYMENT: "inapp_purchase/stripe/confirm",
  CREATE_STRIPE_PAYMENT: "inapp_purchase/stripe/create_stripe_payment",
  PAYMENT_METHODS: "inapp_purchase/stripe/payment_settings",
  DETACH_PAYMENT_METHOD: "inapp_purchase/stripe/detach_payment_method",
  CREATE_PAYMENT_METHOD: "inapp_purchase/stripe/payment_method",
  RECONFIRM_PAYMENT: "inapp_purchase/stripe/reconfirm",
  INAPP_PURCHASE_SETTINGS: "inapp_purchase/purchase_settings",
  PAYMENT_COUNTRIES: "inapp_purchase/payment_countries",
  SET_PAYMENT_COUNTRY: "inapp_purchase/payment_country",
  PAYPAL_PAYMENT: "inapp_purchase/paypal/payment",
  PAYPAL_CAPTURE: "inapp_purchase/paypal/capture",
  SAVED_CARDS: "inapp_purchase/get_saved_cards",
  DELETE_SAVED_CARD: "inapp_purchase/delete_saved_card",
  COUPON_ADD: "coupon/add_coupon_hybrid",
  COUPON_GET_DEVICE_COUPONS: "coupon/get_device_coupons_hybrid",
  COUPON_GET_SUPPORTED_COUNTRIES: "coupon/get_supported_countries_hybrid",
  GET_PRODUCT_DETAIL: `${API_BASE_URL_NEW}/esim/sim/product/details`,
});

/**
 * @typedef ApiMeta
 * @property {string?} next
 */

/**
 * @typedef SuccessResponse
 * @property {boolean} success
 */

/**
 * @typedef PaymentMethod
 * @property {string?} id
 * @property {StripeCard} card
 * @property {string?} customer
 * @property {boolean} livemode
 * @property {string?} type
 */

/**
 * @typedef StripeCard
 * @property {string?} brand
 * @property {string?} fingerprint
 */

/** */

//

/**
 * @template E
 * @param {AxiosInstance} axios
 * @param {E} data
 * @returns {Promise<AxiosResponse<{"success": true}&E>>}
 */
module.exports.echo = function echo(axios, data) {
  return axios.post(ENDPOINT_PATH.ECHO, data);
};

/**
 * @typedef {{}} ApiDeviceRegisterRequest
 */

/**
 * @typedef ApiDeviceRegisterResponse
 * @property {string} guid
 */

/**
 * @param {AxiosInstance} axios
 * @param {ApiDeviceRegisterRequest} data
 * @returns {Promise<AxiosResponse<ApiDeviceRegisterResponse>>}
 */
module.exports.device_register = function device_register(axios, data) {
  return axios.post(ENDPOINT_PATH.DEVICE_REGISTER, data);
};

/**
 * @typedef {{}} ApiSettingsRequest
 */

/**
 * @typedef ApiSettingsResponse
 * @property {string} uid
 * @property {string} agora_app_id
 * @property {string} agora_public_key
 * @property {ApiSettingsResponseWebsocketData} websocket
 * @property {number} discover_period -- int
 */
/**
 * @typedef ApiSettingsResponseWebsocketData
 * @property {number} heartbeat -- int
 * @property {string} url
 */

/**
 * @param {AxiosInstance} axios
 * @param {ApiSettingsRequest} [data={}]
 * @returns {Promise<AxiosResponse<ApiSettingsResponse>>}
 */
module.exports.settings = function settings(axios, data = {}) {
  return axios.post(ENDPOINT_PATH.SETTINGS, data);
};

/**
 * @typedef DetachPaymentMethodInstance
 * @property {string?} payment_method_id
 */

/**
 * @param {AxiosInstance} axios
 * @param {DetachPaymentMethodInstance} data
 * @returns {Promise<AxiosResponse<PaymentMethod>>}
 */
module.exports.detach_payment_method = function detach_payment_method(
  axios,
  data
) {
  return axios.post(ENDPOINT_PATH.DETACH_PAYMENT_METHOD, data);
};

const helpers = require("../helper/index.js");

module.exports.create_stripe_payment = function payment(axios, data) {
  return axios.post(ENDPOINT_PATH.CREATE_STRIPE_PAYMENT, {
    ...data,
    fbc: helpers.getCookie("_fbc"),
    fbp: helpers.getCookie("_fbp"),
    source_url: window.location.href,
  });
};

module.exports.inapp_purchase_settings = function inapp_purchase_settings(
  axios
) {
  return axios.post(ENDPOINT_PATH.INAPP_PURCHASE_SETTINGS);
};

module.exports.payment_countries = function payment_countries(axios) {
  return axios.post(ENDPOINT_PATH.PAYMENT_COUNTRIES);
};

module.exports.set_payment_country = function set_payment_country(axios, data) {
  return axios.post(ENDPOINT_PATH.SET_PAYMENT_COUNTRY, data);
};

module.exports.confirm_payment = function confirm_payment(axios, data) {
  return axios.post(ENDPOINT_PATH.CONFIRM_PAYMENT, {
    ...data,
    fbc: helpers.getCookie("_fbc"),
    fbp: helpers.getCookie("_fbp"),
    source_url: window.location.href,
  });
};

module.exports.reconfirm_payment = function reconfirm_payment(axios, data) {
  return axios.post(ENDPOINT_PATH.RECONFIRM_PAYMENT, {
    ...data,
  });
};

module.exports.payment_methods = function payment_methods(axios, data) {
  return axios.post(ENDPOINT_PATH.PAYMENT_METHODS, data);
};

module.exports.create_payment_method = function create_payment_method(
  axios,
  data
) {
  return axios.post(ENDPOINT_PATH.CREATE_PAYMENT_METHOD, {
    ...data,
    fbc: helpers.getCookie("_fbc"),
    fbp: helpers.getCookie("_fbp"),
    source_url: window.location.href,
  });
};

module.exports.paypal_payment = function (axios, data) {
  return axios.post(ENDPOINT_PATH.PAYPAL_PAYMENT, data);
};

module.exports.paypal_capture = function (axios, data) {
  return axios.post(ENDPOINT_PATH.PAYPAL_CAPTURE, data);
};

module.exports.saved_cards = function (axios, data) {
  return axios.post(ENDPOINT_PATH.SAVED_CARDS, data);
};

module.exports.delete_saved_card = function (axios, data) {
  return axios.post(ENDPOINT_PATH.DELETE_SAVED_CARD, data);
};

module.exports.add_coupon = function (axios, data) {
  return axios.post(ENDPOINT_PATH.COUPON_ADD, data);
};

module.exports.get_device_coupons = function (axios, data) {
  return axios.post(ENDPOINT_PATH.COUPON_GET_DEVICE_COUPONS, data);
};

module.exports.get_coupon_supported_countries = function (axios, data) {
  return axios.post(ENDPOINT_PATH.COUPON_GET_SUPPORTED_COUNTRIES, data);
};

module.exports.get_product_detail = function (axios, data) {
  return axios.post(ENDPOINT_PATH.GET_PRODUCT_DETAIL, data);
};
